<div class="custom-popover">
    <!-- Your popover content here -->
    <label for=""  style="max-width: 160px;" class="text-center mb-1 label-txt">Are you sure you want to delete ?</label>
    <div class="d-flex justify-content-center">
        <button class="btn  btn-no  text-white success-btn " (click)="confirmAction()" >Yes</button>
        <button class="btn btn-no  text-white danger-btn ms-2" (click)="closePopover()" 
        >No</button>
      </div>
  </div>
  